import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TableFiltersSkeleton from "../../components/skeletons/TableFiltersSkeleton";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import {
  GetCollaborationStoresFilter,
  GetCollaborationStoresResponse,
} from "../../models/collaborationStores.model";
import { useMutation } from "react-query";
import {
  GetCollaborationStoreExcel,
  GetCollaborationStores,
} from "../../services/collaborationStores.service";
import CollaborationStoresListFilters from "../../components/Filters/collaborationStoresListFilters";
import { PaginationInfo } from "../../models/security.model";
import CollaborationStoreTable from "../../components/table/CollaborationStoreTable";
import { useHistory } from "react-router-dom";

const CollaborationStores = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [collaborationStoresList, setCollaborationStoresList] = useState<
    GetCollaborationStoresResponse[]
  >([]);
  const [filterObject, setFilterObject] = useState<
    GetCollaborationStoresFilter
  >();
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    },
  );
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    },
  );
  const history = useHistory<{
    key: string;
  }>();

  const handleExportExcel = () => {
    GetCollaborationStoreExcelMutate({
      ...filterObject,
    });
  };
  const { mutate: GetCollaborationStoreExcelMutate } = useMutation(
    GetCollaborationStoreExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    },
  );

  const { mutate: GetCollaborationStoresMutate, isLoading } = useMutation(
    GetCollaborationStores,
    {
      onSuccess: (data: ApiResultModel<GetCollaborationStoresResponse[]>) => {
        if (data) {
          setCollaborationStoresList(data.data);
          setPageInfo(data.pageInfo);
        }
      },
      onError: () => {},
    },
  );
  const handleRouteToCollaborationStoreDetail = (rowId: string) => {
    history.push({
      pathname: "/store/CollaborationStoreDetail",
      state: {
        key: rowId,
      },
    });
    localStorage.setItem("DETAIL_COLLABORATION", String(rowId));
  };

  useEffect(() => {
    if (filterObject) {
      GetCollaborationStoresMutate({
        filter: filterObject,
        paginationInfo: currentPaginationInfo,
      });
    }
  }, [filterObject, currentPaginationInfo]);

  useEffect(() => {
    GetCollaborationStoresMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, []);

  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter &&
          (!isLoading ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <CollaborationStoresListFilters
                filterObject={filterObject!}
                setFilterObject={setFilterObject}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableFiltersSkeleton />
            </span>
          ))}
        <Grid item xs={12}>
          {
            <CollaborationStoreTable
              collaborationStoresList={collaborationStoresList}
              pageInfo={pageInfo}
              currentPaginationInfo={currentPaginationInfo}
              setCurrentPaginationInfo={setCurrentPaginationInfo}
              handleRouteToCollaborationStoreDetail={
                handleRouteToCollaborationStoreDetail
              }
            />
          }
        </Grid>
      </Grid>
    </div>
  );
};

export default CollaborationStores;
